import React from 'react';
import { RecipeList } from './Recipe';

/**
 * Recipes Component
 *
 * Link menu items to inventory ingredients:
 * - Create recipes for menu items
 * - Define ingredient quantities
 * - Support for menu item variants
 * - Track food cost percentage
 */

export default function Recipes() {
  return <RecipeList />;
}
